/*
  Trickcal: Chibi Go Catalog - Full UI Integration
  - API Pattern: GET-based (similar to wuwa02, same API owner)
  - Character endpoint: http://n.mxwy.ltd/api/card/?game=嘟嘟脸恶作剧&tag=三星
  - Search endpoint: http://n.mxwy.ltd/api/deck/?cards={ids}&game=嘟嘟脸恶作剧&...
  - Cards parameter: pipe-separated with repeats (e.g., 17600|17632|17600)
  - Normalizes ddl6_ prefix from character names
  - Filters out server cards (ddl_初始号, ddl_欧美, etc.) from display
  - Parses source field for account details
*/
(function(){
  /* ====== API Sources Declaration ====== */
  const API_SOURCES = {
    'trickcal': { name: 'Trickcal API', enabled: true }
  };
  
  const escapeHtml = s => String(s||'').replace(/[&<>"']|'/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]));
  
  // API endpoints - Using CORS proxy (same as wuwa02)
  const CORS_PROXY = 'https://corsproxy.io/?';
  const TRICKCAL_CHARS_API = CORS_PROXY + encodeURIComponent('http://n.mxwy.ltd/api/card/?game=嘟嘟脸恶作剧&tag=三星');
  const TRICKCAL_SEARCH_BASE = 'http://n.mxwy.ltd/api/deck/';
  const GAME_PARAM = encodeURIComponent('嘟嘟脸恶作剧');
  
  let selected = {};
  let characterList = [];
  let characterMap = {}; // Map ID to character data
  
  // Pagination state
  let allFilteredAccounts = []; // All accounts currently displayed
  let currentPage = 0; // Last page we fetched
  let totalPages = 0; // Total pages available from API
  let currentSearchParams = null; // Store search params for continuation
  let currentSelectedServer = ''; // Store selected server for continuation
  let isLoadingMore = false; // Prevent multiple simultaneous loads
  const ACCOUNTS_PER_BATCH = 5; // Show 5 accounts per batch
  
  // Settings & Translations Initialization
  let trickcalSettings = {translations_json: '{}', images_json: '{}', api_toggles: {}};
  try {
    const el = document.getElementById('catalog-trickcal-settings');
    if (el) trickcalSettings = JSON.parse(el.textContent);
  } catch(e) { 
    console.error('[Trickcal] Failed to parse settings:', e);
    trickcalSettings = {translations_json: '{}', images_json: '{}', api_toggles: {}}; 
  }
  
  // console.log('[Trickcal] Raw settings from Liquid:', trickcalSettings);
  // console.log('[Trickcal] API toggles received:', trickcalSettings.api_toggles);
  
  // Override API_SOURCES enabled state from admin settings
  if (trickcalSettings.api_toggles) {
    Object.keys(API_SOURCES).forEach(apiId => {
      const oldState = API_SOURCES[apiId].enabled;
      if (trickcalSettings.api_toggles.hasOwnProperty(apiId)) {
        API_SOURCES[apiId].enabled = trickcalSettings.api_toggles[apiId] === true;
        // console.log(`[Trickcal] API '${apiId}': ${oldState} → ${API_SOURCES[apiId].enabled} (admin setting: ${trickcalSettings.api_toggles[apiId]})`);
      }
    });
  }
  
  // console.log('[Trickcal] ═══════════════════════════════════════════');
  // console.log('[Trickcal] FINAL API SOURCES STATUS:');
  Object.entries(API_SOURCES).forEach(([id, api]) => {
    // console.log(`[Trickcal]   ${id}: ${api.enabled ? '✅ ENABLED' : '❌ DISABLED'} (${api.name})`);
  });
  // console.log('[Trickcal] ═══════════════════════════════════════════');
  
  const enableApiCalls = API_SOURCES.trickcal.enabled;

  let nameTranslations = {}, nameTranslationsMap = {};
  try {
    nameTranslations = JSON.parse(trickcalSettings.translations_json || '{}');
    Object.entries(nameTranslations).forEach(([key, val]) => {
      key.split('|').map(k => k.trim()).forEach(k => { if (k) nameTranslationsMap[k] = val; });
    });
  } catch(e) { 
    console.warn('[Trickcal] Failed to parse translations:', e);
    nameTranslations = {}; 
    nameTranslationsMap = {}; 
  }

  let customImages = {}, customImagesMap = {};
  try {
    customImages = JSON.parse(trickcalSettings.images_json || '{}');
    Object.entries(customImages).forEach(([key, val]) => {
      key.split('|').map(k => k.trim()).forEach(k => { if (k) customImagesMap[k] = val; });
    });
  } catch(e) { 
    console.warn('[Trickcal] Failed to parse custom images:', e);
    customImages = {}; 
    customImagesMap = {}; 
  }

  // Name normalization: strip ddl6_ prefix
  const normalizeName = name => {
    if (!name) return name;
    return name.startsWith('ddl6_') ? name.slice(5) : name;
  };
  
  // ID obfuscation logic (same as chushi-app.js)
  function privateToPublicID(privateID) {
    if (!privateID) return '';
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const randomChars = len => Array.from({length: len}, () => chars[Math.floor(Math.random() * chars.length)]).join('');
    const reversed = String(privateID).split('').reverse().join('');
    // Swap neighboring pairs in reversed
    let arr = reversed.split('');
    for (let i = 0; i + 1 < arr.length; i += 2) {
      [arr[i], arr[i+1]] = [arr[i+1], arr[i]];
    }
    const swapped = arr.join('');
    return randomChars(2) + swapped + randomChars(2);
  }
  
  // Translation helper function
  const translateName = name => {
    const normalized = normalizeName(name);
    const translated = nameTranslationsMap[normalized] || nameTranslationsMap[name] || normalized;
    return translated;
  };
  
  // Custom image helper function
  const getCustomImage = name => {
    const normalized = normalizeName(name);
    return customImagesMap[normalized] || customImagesMap[name] || null;
  };
  
  // Server card IDs mapping
  const SERVER_CARDS = {
    17630: 'Asia',
    17632: 'Global',
    17633: 'TW/HK/MO' // Filter out this server
  };
  
  // Detect server from card IDs in account
  const detectServerFromCards = (cards) => {
    if (!cards || !Array.isArray(cards)) return 'Unknown';
    
    for (const card of cards) {
      if (SERVER_CARDS[card.id]) {
        return SERVER_CARDS[card.id];
      }
    }
    return 'Unknown';
  };
  
  // Server translation helper (kept for backward compatibility)
  const translateServer = (serverStr) => {
    if (!serverStr) return 'Unknown';
    if (serverStr.includes('国际服')) return 'Global';
    if (serverStr.includes('美洲')) return 'America';
    if (serverStr.includes('欧洲')) return 'Europe';
    if (serverStr.includes('亚洲')) return 'Asia';
    return serverStr;
  };
  
  // Parse source field to extract account details
  // Example: "国际服   安卓 嘟嘟脸恶作剧    昵称:Aria   水晶叶:30   抽卡券:30   新手招募券:50   更新时间:2025-10-20 01:52:38    LCH"
  const parseSource = (source) => {
    if (!source) return {};
    
    const result = {
      server: '',
      platform: '',
      nickname: '',
      crystalLeaves: '',
      gachaCoupons: '',
      beginnerCoupons: '',
      updateTime: ''
    };
    
    // Extract server (国际服, etc.)
    const serverMatch = source.match(/(国际服|美洲|欧洲|亚洲)/);
    if (serverMatch) result.server = translateServer(serverMatch[1]);
    
    // Extract platform (安卓, iOS, etc.)
    const platformMatch = source.match(/(安卓|iOS|PC)/);
    if (platformMatch) result.platform = platformMatch[1];
    
    // Extract nickname
    const nicknameMatch = source.match(/昵称[:：]([^\s]+)/);
    if (nicknameMatch) result.nickname = nicknameMatch[1];
    
    // Extract resources
    const crystalMatch = source.match(/水晶叶[:：](\d+)/);
    if (crystalMatch) result.crystalLeaves = crystalMatch[1];
    
    const gachaMatch = source.match(/抽卡券[:：](\d+)/);
    if (gachaMatch) result.gachaCoupons = gachaMatch[1];
    
    const beginnerMatch = source.match(/新手招募券[:：](\d+)/);
    if (beginnerMatch) result.beginnerCoupons = beginnerMatch[1];
    
    // Extract update time
    const timeMatch = source.match(/更新时间[:：]([^\s]+\s+[^\s]+)/);
    if (timeMatch) result.updateTime = timeMatch[1];
    
    return result;
  };
  
  // Filter out server/system cards (cards that start with ddl_ but not ddl6_)
  const isServerCard = (name) => {
    if (!name) return false;
    return name.startsWith('ddl_') && !name.startsWith('ddl6_');
  };

  function updateSelectedUI() {
    const totalCount = Object.values(selected).reduce((sum, sel) => sum + (sel.count || 0), 0);
    const selectedCountEl = document.querySelector("#selectedCount");
    if (selectedCountEl) selectedCountEl.textContent = totalCount;
  }
  
  // Scroll to results section for better UX
  const scrollToResults = () => document.querySelector("#results")?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  
  function updateThumbDisplay(thumb, id) {
    const count = selected[id]?.count || 0;
    const existingBadge = thumb.querySelector('.count-badge');
    if (count > 0) {
      thumb.classList.add('selected');
      if (existingBadge) {
        existingBadge.textContent = count;
      } else {
        const badge = document.createElement('div');
        badge.className = 'count-badge';
        badge.textContent = count;
        thumb.querySelector('.thumb-img-container').appendChild(badge);
      }
    } else {
      thumb.classList.remove('selected');
      if (existingBadge) existingBadge.remove();
    }
  }
  
  function clearSelection() {
    selected = {};
    document.querySelectorAll('.thumb').forEach(thumb => {
      thumb.classList.remove('selected');
      const badge = thumb.querySelector('.count-badge');
      if (badge) badge.remove();
    });
    updateSelectedUI();
  }
  
  function showToast(message, duration = 3000) {
    const toast = document.querySelector("#toast");
    if (!toast) return;
    
    // Update toast message if provided
    if (message) {
      const toastText = toast.querySelector('.toast-content span');
      if (toastText) toastText.textContent = message;
    }
    
    toast.classList.remove('hidden');
    toast.offsetHeight;
    toast.classList.add('show');
    
    if (duration > 0) {
      setTimeout(() => { toast.classList.remove('show'); setTimeout(() => toast.classList.add('hidden'), 300); }, duration);
    }
  }
  
  function hideToast() {
    const toast = document.querySelector("#toast");
    if (!toast) return;
    toast.classList.remove('show');
    setTimeout(() => toast.classList.add('hidden'), 300);
  }
  
  function copyToClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(() => showToast('ID copied! Please share this with customer service to get price quotation.')).catch(() => fallbackCopy(text));
    } else fallbackCopy(text);
  }
  
  function fallbackCopy(text) {
    const ta = document.createElement('textarea');
    ta.value = text; ta.style.cssText = 'position:fixed;left:-9999px';
    document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); showToast('ID copied! Please share this with customer service to get price quotation.'); } catch(e) { console.error('Copy failed:', e); }
    document.body.removeChild(ta);
  }
  
  function renderFilterUI() {
    const container = document.querySelector("#filters");
    if (!container) return;
    container.innerHTML = '';
    if (!characterList.length) {
      container.innerHTML = '<div class="no-data">No character data.</div>';
      return;
    }
    
    // Filter out server cards from display
    const displayChars = characterList.filter(char => !isServerCard(char.name));
    
    displayChars.forEach(char => {
      const thumb = document.createElement('div');
      thumb.className = 'thumb';
      thumb.dataset.id = char.id;
      
      // Apply translation and custom image
      const displayName = translateName(char.name);
      const customImg = getCustomImage(char.name);
      const displayImg = customImg || char.role_img;
      
      thumb.innerHTML = `
        <div class="thumb-img-container">
          <img alt="${escapeHtml(displayName)}" src="${escapeHtml(displayImg)}" loading="lazy"/>
        </div>
        <div class="label">${escapeHtml(displayName)}</div>
      `;
      thumb.onclick = () => {
        const id = thumb.dataset.id;
        if (selected[id]) {
          selected[id].count++;
        } else {
          selected[id] = { count: 1, name: displayName, img: displayImg, originalName: char.name };
        }
        updateThumbDisplay(thumb, id);
        updateSelectedUI();
      };
      container.appendChild(thumb);
    });
    updateSelectedUI();
  }
  
  function loadResources() {
    // Show API status banner if disabled
    const disabledApis = Object.entries(API_SOURCES).filter(([id, api]) => !api.enabled).map(([id, api]) => api.name);
    if (disabledApis.length > 0) {
      // console.log('[Trickcal] Some APIs are disabled - showing warning banner');
      const searchSection = document.querySelector("#trickcal");
      if (searchSection) {
        const banner = document.createElement('div');
        banner.style.cssText = 'background: #fef3c7; border: 2px solid #f59e0b; border-radius: 8px; padding: 12px 16px; margin: 16px 0; color: #92400e; font-weight: 500; text-align: center;';
        banner.innerHTML = `⚠️ API calls are currently disabled. Search functionality is temporarily unavailable. Please contact Gachamacha support for assistance.`;
        searchSection.insertBefore(banner, searchSection.firstChild);
      }
    }
    
    if (!enableApiCalls) {
      // console.log('[Trickcal] ❌ Skipping Trickcal API (disabled)');
      const container = document.querySelector("#filters");
      if (container) container.innerHTML = '<div class="no-data">⚠️ API calls are currently disabled.<br><br>Please contact Gachamacha support for assistance.</div>';
      return;
    }
    
    // console.log('[Trickcal] ✅ Loading Trickcal API');
    // console.log('[Trickcal] API URL:', TRICKCAL_CHARS_API);
    
    fetch(TRICKCAL_CHARS_API)
      .then(r => {
        // console.log('[Trickcal] Fetch response status:', r.status, r.statusText);
        // console.log('[Trickcal] Response headers:', {
        //   contentType: r.headers.get('content-type'),
        //   corsHeaders: r.headers.get('access-control-allow-origin')
        // });
        if (!r.ok) {
          throw new Error(`HTTP ${r.status}: ${r.statusText}`);
        }
        return r.json();
      })
      .then(payload => {
        // console.log('[Trickcal] Raw API response:', payload);
        // console.log('[Trickcal] Response type:', typeof payload, 'Is array:', Array.isArray(payload));
        
        characterList = Array.isArray(payload) ? payload : [];
        // console.log(`[Trickcal] Loaded ${characterList.length} characters from API`);
        
        // if (characterList.length > 0) {
          // console.log('[Trickcal] First character sample:', characterList[0]);
          // console.log('[Trickcal] Character structure:', {
        //     id: characterList[0]?.id,
        //     name: characterList[0]?.name,
        //     role_img: characterList[0]?.role_img,
        //     weight: characterList[0]?.weight
        //   });
        // }
        
        // Build character map for quick lookup
        characterList.forEach(char => {
          characterMap[char.id] = char;
        });
        
        renderFilterUI();
      })
      .catch(err => {
        console.error("[Trickcal] Filter load failed:", err);
        console.error("[Trickcal] Error details:", {
          message: err.message,
          stack: err.stack,
          name: err.name
        });
        const container = document.querySelector("#filters");
        if (container) container.innerHTML = '<div class="no-data">Failed to load character list. Please refresh the page.</div>';
      });
  }
  
  // Fetch pages incrementally until we have enough filtered results
  async function fetchNextBatch(baseParams, selectedCardIds, selectedServerCardId, targetCount, isLoadMore = false) {
    const filteredAccounts = [];
    let lastPage = currentPage;
    let totalPagesAvailable = 0;
    let checkedPages = 0;
    const maxPagesToCheck = 10; // Safety limit to prevent infinite loops
    const resultsEl = document.querySelector("#results");
    
    // console.log(`[Trickcal] === Fetching next batch (target: ${targetCount} accounts, starting from page ${lastPage + 1}) ===`);
    
    while (filteredAccounts.length < targetCount && checkedPages < maxPagesToCheck) {
      lastPage++;
      checkedPages++;
      
      // Update loading message with progress
      if (resultsEl) {
        if (isLoadMore) {
          // For load more, append loading indicator at the bottom
          let loadingDiv = resultsEl.querySelector('#loadMoreLoading');
          if (!loadingDiv) {
            loadingDiv = document.createElement('div');
            loadingDiv.id = 'loadMoreLoading';
            loadingDiv.className = 'loading';
            resultsEl.appendChild(loadingDiv);
          }
          loadingDiv.textContent = `🔍 Searching page ${lastPage}... Found ${filteredAccounts.length} matching account(s) so far`;
        } else {
          // For initial search, replace entire content
          resultsEl.innerHTML = `<div class="loading">🔍 Searching page ${lastPage}... Found ${filteredAccounts.length} matching account(s) so far</div>`;
        }
      }
      
      const pageParams = new URLSearchParams(baseParams);
      pageParams.set('page', lastPage.toString());
      const baseSearchUrl = `${TRICKCAL_SEARCH_BASE}?${pageParams.toString()}`;
      const pageUrl = CORS_PROXY + encodeURIComponent(baseSearchUrl);
      
      // console.log(`[Trickcal] Fetching page ${lastPage}...`);
      
      try {
        const response = await fetch(pageUrl);
        
        if (!response.ok) {
          console.error(`[Trickcal] Page ${lastPage} HTTP error: ${response.status} ${response.statusText}`);
          const errorText = await response.text();
          console.error('[Trickcal] Error response:', errorText);
          break;
        }
        
        const data = await response.json();
        // console.log(`[Trickcal] Page ${lastPage} raw response:`, data);
        
        // Store total pages from first response
        if (totalPagesAvailable === 0) {
          totalPagesAvailable = Math.ceil(data.count / 20) || 1; // API returns count, assume 20 per page
          // console.log(`[Trickcal] Total pages available: ${totalPagesAvailable}`);
        }
        
        const pageAccounts = data.results || [];
        // console.log(`[Trickcal] Page ${lastPage}: ${pageAccounts.length} accounts fetched`);
        
        // Filter accounts based on server
        const matchingAccounts = pageAccounts.filter(account => {
          const accountCards = account.cards || [];
          
          // Always filter out TW/HK/MO server (17633)
          const hasTWServer = accountCards.some(card => card.id === 17633);
          if (hasTWServer) {
            // console.log(`[Trickcal] Filtered out TW/HK/MO account: ${account.name}`);
            return false;
          }
          
          // If a specific server is selected, filter by that server
          if (selectedServerCardId) {
            const hasSelectedServer = accountCards.some(card => card.id === parseInt(selectedServerCardId));
            if (!hasSelectedServer) {
              const accountServer = detectServerFromCards(accountCards);
              // console.log(`[Trickcal] Filtered out account ${account.name}: Server is ${accountServer}, looking for ${SERVER_CARDS[selectedServerCardId]}`);
              return false;
            }
          }
          
          return true;
        });
        
        // console.log(`[Trickcal] Page ${lastPage}: ${matchingAccounts.length} matching accounts after filter`);
        filteredAccounts.push(...matchingAccounts);
        
        // Stop if we've reached the last page
        if (lastPage >= totalPagesAvailable) {
          // console.log('[Trickcal] Reached last page');
          break;
        }
        
        // Stop if we have enough results
        if (filteredAccounts.length >= targetCount) {
          // console.log(`[Trickcal] Target reached: ${filteredAccounts.length} >= ${targetCount}`);
          break;
        }
      } catch (err) {
        // console.error(`[Trickcal] Error fetching page ${lastPage}:`, err);
        break;
      }
    }
    
    return {
      filteredAccounts: filteredAccounts,
      lastPage: lastPage,
      totalPages: totalPagesAvailable,
      hasMore: lastPage < totalPagesAvailable
    };
  }
  
  async function performSearch() {
    const resultsEl = document.querySelector("#results");
    if (!resultsEl) return;
    if (!Object.keys(selected).length) {
      resultsEl.innerHTML = '<div class="no-data">Please select at least one character.</div>';
      return;
    }
    
    // Check if API calls are disabled
    if (!enableApiCalls) {
      // console.log('[Trickcal] API calls are disabled via admin settings');
      resultsEl.innerHTML = '<div class="no-data">⚠️ API calls are currently disabled.<br><br>Please contact Gachamacha support for assistance.</div>';
      showToast('⚠️ API calls are currently disabled', 3000);
      return;
    }
    
    // console.log('[Trickcal] ═══════════════════════════════════════════');
    // console.log('[Trickcal] SEARCH: Checking API states...');
    // console.log(`[Trickcal] Trickcal API: enabled=${API_SOURCES.trickcal.enabled}`);
    // console.log('[Trickcal] ✅ Querying Trickcal API');
    // console.log('[Trickcal] ═══════════════════════════════════════════');
    
    // Disable search button during search with spinner
    const searchBtn = document.querySelector("#searchBtn");
    if (searchBtn) {
      searchBtn.disabled = true;
      searchBtn.innerHTML = '<span style="display: inline-flex; align-items: center; gap: 8px;"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="animation: spin 1s linear infinite;"><circle cx="12" cy="12" r="10" opacity="0.25"></circle><path d="M12 2a10 10 0 0 1 10 10" stroke-linecap="round"></path></svg>Searching...</span>';
    }
    
    // Show toast notification
    showToast('🔍 Searching for matching accounts... Please wait.', 0);
    
    resultsEl.innerHTML = '<div class="loading">🔍 Searching for matching accounts...</div>';
    
    // Build cards parameter: pipe-separated IDs with repeats
    const cardIds = [];
    Object.keys(selected).forEach(id => {
      const count = selected[id].count;
      for (let i = 0; i < count; i++) {
        cardIds.push(id);
      }
    });
    
    const cardsParam = cardIds.join('|');
    
    // Build base search parameters
    const baseParams = new URLSearchParams({
      cards: cardsParam,
      game: '嘟嘟脸恶作剧',
      limit: '',
      sourceNumberMin: '',
      sourceNumberMax: '',
      deckid: '',
      asort: 'desc'
    });
    
    // console.log('[Trickcal] Selected cards:', cardIds);
    
    // Get selected server filter
    const serverSelect = document.querySelector('#serverSelect');
    const selectedServerCardId = serverSelect ? serverSelect.value : '';
    // console.log('[Trickcal] Selected server filter:', selectedServerCardId || 'All Servers');
    
    // Scroll to results for better UX
    scrollToResults();
    
    try {
      // Reset state for new search
      currentPage = 0;
      allFilteredAccounts = [];
      currentSearchParams = baseParams;
      currentSelectedServer = selectedServerCardId;
      
      // Fetch pages incrementally until we have ACCOUNTS_PER_BATCH filtered results
      resultsEl.innerHTML = '<div class="loading">🔍 Searching for matching accounts...</div>';
      
      const result = await fetchNextBatch(baseParams, cardIds, selectedServerCardId, ACCOUNTS_PER_BATCH);
      
      if (result.filteredAccounts.length === 0) {
        hideToast();
        if (result.lastPage === 0) {
          resultsEl.innerHTML = '<div class="no-data">Search failed. The API may be experiencing issues. Please try again.</div>';
          setTimeout(() => showToast('❌ Search failed. The API may be experiencing issues.', 3000), 300);
        } else {
          resultsEl.innerHTML = '<div class="no-data">No matching accounts found for the selected server.</div>';
          setTimeout(() => showToast('ℹ️ No matching accounts found.', 3000), 300);
        }
        return;
      }
      
      // Store results
      allFilteredAccounts = result.filteredAccounts;
      currentPage = result.lastPage;
      totalPages = result.totalPages;
      
      // console.log(`[Trickcal] Found ${result.filteredAccounts.length} matching accounts after checking ${result.lastPage} pages`);
      
      // Render results
      renderSearchResults({
        data: result.filteredAccounts,
        totalFetched: result.filteredAccounts.length,
        totalPages: result.totalPages,
        currentPage: result.lastPage,
        hasMore: result.hasMore
      });
      
      // Hide toast and show success message
      hideToast();
      setTimeout(() => showToast(`✅ Found ${result.filteredAccounts.length} matching account(s)!`, 3000), 300);
      
    } catch (err) {
      console.error('[Trickcal] Search failed:', err);
      resultsEl.innerHTML = '<div class="no-data">Search failed. Please try again.</div>';
      hideToast();
      setTimeout(() => showToast('❌ Search failed. Please try again.', 3000), 300);
    } finally {
      // Re-enable search button
      if (searchBtn) {
        searchBtn.disabled = false;
        searchBtn.textContent = 'Search';
      }
    }
  }
  
  function renderSearchResults(data) {
    const resultsEl = document.querySelector("#results");
    if (!resultsEl) return;
    
    if (!data.data || !data.data.length) {
      resultsEl.innerHTML = '<div class="no-data">No matching accounts found.</div>';
      return;
    }
    
    const accounts = data.data;
    const hasMore = data.hasMore || false;
    const currentPageNum = data.currentPage || 0;
    const totalPagesNum = data.totalPages || 0;
    
    let html = `<div class="results-header">Showing ${accounts.length} matching account(s)</div>`;
    
    accounts.forEach(account => {
      // Parse source field for account details
      const sourceInfo = parseSource(account.source);
      
      // Get character cards for this account
      const accountCards = account.cards || [];
      
      // Detect server from card IDs (more accurate than parsing source)
      const detectedServer = detectServerFromCards(accountCards);
      
      // Count duplicates
      const cardCounts = {};
      const cardData = {};
      
      accountCards.forEach(card => {
        const cardId = card.id;
        if (!cardCounts[cardId]) {
          cardCounts[cardId] = 0;
          cardData[cardId] = card;
        }
        cardCounts[cardId]++;
      });
      
      // Create array of unique cards with counts, filter out server cards
      const uniqueCards = Object.keys(cardCounts)
        .map(cardId => ({
          ...cardData[cardId],
          count: cardCounts[cardId]
        }))
        .filter(card => !isServerCard(card.name));
      
      // Render character thumbnails
      const characterThumbs = uniqueCards.map(card => {
        const displayName = translateName(card.name);
        const customImg = getCustomImage(card.name);
        const displayImg = customImg || card.role_img;
        const count = card.count || 1;
        
        return `<div class="char-item">
          <img src="${escapeHtml(displayImg)}" alt="${escapeHtml(displayName)}" title="${escapeHtml(displayName)}" class="char-thumb" loading="lazy"/>
          <div class="char-label">${escapeHtml(displayName)}</div>
          ${count > 1 ? `<div class="char-count">x${count}</div>` : ''}
        </div>`;
      }).join('');
      
      // Build account info display - use detected server instead of parsed server
      const infoItems = [];
      if (detectedServer) infoItems.push(`<strong>Server:</strong> ${escapeHtml(detectedServer)}`);
      if (sourceInfo.nickname) infoItems.push(`<strong>Nickname:</strong> ${escapeHtml(sourceInfo.nickname)}`);
      if (sourceInfo.crystalLeaves) infoItems.push(`<strong>Crystal Leaves:</strong> ${escapeHtml(sourceInfo.crystalLeaves)}`);
      if (sourceInfo.gachaCoupons) infoItems.push(`<strong>Card Rate Up Tickets:</strong> ${escapeHtml(sourceInfo.gachaCoupons)}`);
      if (sourceInfo.beginnerCoupons) infoItems.push(`<strong>Debut Recruitment Tickets:</strong> ${escapeHtml(sourceInfo.beginnerCoupons)}`);
      
      html += `
        <div class="result-card">
          <div class="result-header">
            <div class="result-id">
              <strong>Account ID:</strong> ${escapeHtml(privateToPublicID(account.name || ''))}
            </div>
            <button class="copy-btn" onclick="copyToClipboard('${escapeHtml(privateToPublicID(account.name || ''))}')">Copy ID</button>
          </div>
          <div class="result-body">
            <div class="result-info">
              ${infoItems.map(item => `<div class="result-detail">${item}</div>`).join('')}
            </div>
            <div class="character-grid">
              ${characterThumbs}
            </div>
          </div>
        </div>
      `;
    });
    
    // Add "Load More" button if there are more pages to search
    if (hasMore) {
      html += `
        <div style="text-align: center; margin: 20px 0;">
          <button id="loadMoreBtn" class="btn primary" style="padding: 12px 24px;">
            Load More Results
          </button>
        </div>
      `;
    }
    
    resultsEl.innerHTML = html;
    
    // Attach load more handler
    const loadMoreBtn = document.querySelector('#loadMoreBtn');
    if (loadMoreBtn) {
      loadMoreBtn.onclick = loadMoreAccounts;
    }
  }
  
  async function loadMoreAccounts() {
    if (isLoadingMore) {
      console.log('[Trickcal] Already loading more accounts...');
      return;
    }
    
    isLoadingMore = true;
    const loadMoreBtn = document.querySelector('#loadMoreBtn');
    if (loadMoreBtn) {
      loadMoreBtn.textContent = 'Loading...';
      loadMoreBtn.disabled = true;
    }
    
    // console.log('[Trickcal] Loading more accounts...');
    
    try {
      const selectedCardIds = [];
      Object.keys(selected).forEach(id => {
        const count = selected[id].count;
        for (let i = 0; i < count; i++) {
          selectedCardIds.push(id);
        }
      });
      
      const result = await fetchNextBatch(currentSearchParams, selectedCardIds, currentSelectedServer, ACCOUNTS_PER_BATCH, true);
      
      if (result.filteredAccounts.length === 0) {
        console.log('[Trickcal] No more matching accounts found');
        if (loadMoreBtn) loadMoreBtn.parentElement.remove();
        isLoadingMore = false;
        return;
      }
      
      // Update state
      allFilteredAccounts.push(...result.filteredAccounts);
      currentPage = result.lastPage;
      totalPages = result.totalPages;
      
      console.log(`[Trickcal] Loaded ${result.filteredAccounts.length} more accounts. Total displayed: ${allFilteredAccounts.length}`);
      
      // Remove loading indicator
      const loadingDiv = document.querySelector('#loadMoreLoading');
      if (loadingDiv) loadingDiv.remove();
      
      // Append new accounts to existing results
      appendAccounts(result.filteredAccounts, result.hasMore);
    } catch (err) {
      console.error('[Trickcal] Failed to load more accounts:', err);
      if (loadMoreBtn) {
        loadMoreBtn.textContent = 'Load More Results';
        loadMoreBtn.disabled = false;
      }
    }
    
    isLoadingMore = false;
  }
  
  function appendAccounts(accounts, hasMore) {
    const resultsEl = document.querySelector("#results");
    if (!resultsEl) return;
    
    // Update header
    const headerEl = resultsEl.querySelector('.results-header');
    if (headerEl) {
      headerEl.textContent = `Showing ${allFilteredAccounts.length} matching account(s)`;
    }
    
    // Remove old load more button if exists
    const oldLoadMoreBtn = resultsEl.querySelector('#loadMoreBtn');
    if (oldLoadMoreBtn) {
      oldLoadMoreBtn.parentElement.remove();
    }
    
    // Append new account cards
    let html = '';
    accounts.forEach(account => {
      // Parse source field for account details
      const sourceInfo = parseSource(account.source);
      
      // Get character cards for this account
      const accountCards = account.cards || [];
      
      // Detect server from card IDs
      const detectedServer = detectServerFromCards(accountCards);
      
      // Count duplicates
      const cardCounts = {};
      const cardData = {};
      
      accountCards.forEach(card => {
        const cardId = card.id;
        if (!cardCounts[cardId]) {
          cardCounts[cardId] = 0;
          cardData[cardId] = card;
        }
        cardCounts[cardId]++;
      });
      
      // Create array of unique cards with counts, filter out server cards
      const uniqueCards = Object.keys(cardCounts)
        .map(cardId => ({
          ...cardData[cardId],
          count: cardCounts[cardId]
        }))
        .filter(card => !isServerCard(card.name));
      
      // Render character thumbnails
      const characterThumbs = uniqueCards.map(card => {
        const displayName = translateName(card.name);
        const customImg = getCustomImage(card.name);
        const displayImg = customImg || card.role_img;
        const count = card.count || 1;
        
        return `<div class="char-item">
          <img src="${escapeHtml(displayImg)}" alt="${escapeHtml(displayName)}" title="${escapeHtml(displayName)}" class="char-thumb" loading="lazy"/>
          <div class="char-label">${escapeHtml(displayName)}</div>
          ${count > 1 ? `<div class="char-count">x${count}</div>` : ''}
        </div>`;
      }).join('');
      
      // Build account info display
      const infoItems = [];
      if (detectedServer) infoItems.push(`<strong>Server:</strong> ${escapeHtml(detectedServer)}`);
      if (sourceInfo.nickname) infoItems.push(`<strong>Nickname:</strong> ${escapeHtml(sourceInfo.nickname)}`);
      if (sourceInfo.crystalLeaves) infoItems.push(`<strong>Crystal Leaves:</strong> ${escapeHtml(sourceInfo.crystalLeaves)}`);
      if (sourceInfo.gachaCoupons) infoItems.push(`<strong>Card Rate Up Tickets:</strong> ${escapeHtml(sourceInfo.gachaCoupons)}`);
      if (sourceInfo.beginnerCoupons) infoItems.push(`<strong>Debut Recruitment Tickets:</strong> ${escapeHtml(sourceInfo.beginnerCoupons)}`);
      
      html += `
        <div class="result-card">
          <div class="result-header">
            <div class="result-id">
              <strong>Account ID:</strong> ${escapeHtml(privateToPublicID(account.name || ''))}
            </div>
            <button class="copy-btn" onclick="copyToClipboard('${escapeHtml(privateToPublicID(account.name || ''))}')">Copy ID</button>
          </div>
          <div class="result-body">
            <div class="result-info">
              ${infoItems.map(item => `<div class="result-detail">${item}</div>`).join('')}
            </div>
            <div class="character-grid">
              ${characterThumbs}
            </div>
          </div>
        </div>
      `;
    });
    
    // Add new load more button if there are more pages to search
    if (hasMore) {
      html += `
        <div style="text-align: center; margin: 20px 0;">
          <button id="loadMoreBtn" class="btn primary" style="padding: 12px 24px;">
            Load More Results
          </button>
        </div>
      `;
    }
    
    resultsEl.insertAdjacentHTML('beforeend', html);
    
    // Reattach load more handler
    const newLoadMoreBtn = document.querySelector('#loadMoreBtn');
    if (newLoadMoreBtn) {
      newLoadMoreBtn.onclick = loadMoreAccounts;
    }
  }
  
  document.querySelector("#clearBtn")?.addEventListener('click', clearSelection);
  document.querySelector("#searchBtn")?.addEventListener('click', performSearch);
  window.copyToClipboard = copyToClipboard;
  loadResources();
})();
